import * as React from "react";
import { forwardRef } from "react";
const SvgExpand = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.84146 3.23047H12.7621V6.1511M12.7621 3.23047L9.07955 6.85891M6.15892 12.7543L3.23828 12.7718V9.83364M6.92082 9.07174L3.23828 12.7543", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgExpand);
export { ForwardRef as ReactComponent };
